import { Button } from "@dfws/ui";
import { useRevokeOtherSessions, useSessions } from "../../lib/queries";
import { fullDate } from "../mail/format";
import { Notice } from "./parts";
import s from "./Settings.module.css";

function device(ua: string): string {
  const os = /Windows/.test(ua) ? "Windows" : /Android/.test(ua) ? "Android" : /iPhone|iPad/.test(ua) ? "iPhone or iPad" : /Mac OS X/.test(ua) ? "Mac" : /Linux/.test(ua) ? "Linux" : "Unknown device";
  const br = /Edg\//.test(ua) ? "Edge" : /Chrome\//.test(ua) ? "Chrome" : /Firefox\//.test(ua) ? "Firefox" : /Safari\//.test(ua) ? "Safari" : "Browser";
  return `${br} on ${os}`;
}

export function SecuritySection() {
  const sessions = useSessions();
  const revoke = useRevokeOtherSessions();
  const others = (sessions.data?.items ?? []).filter((x) => !x.current).length;
  return (
    <>
      <p className={s.lead}>Where you are signed in to Workspace. Your password is checked by the DevFusion mail server and never stored; Workspace keeps only an app password named DevFusion Workspace, which you can revoke in the mailcow user panel at any time.</p>
      <section className={s.group}>
        <h3 className={s.groupTitle}>Signed-in sessions</h3>
        <ul className={s.list} style={{ marginTop: "var(--space-3)" }}>
          {(sessions.data?.items ?? []).map((x) => (
            <li key={x.id} className={s.listItem}>
              <div className={s.listMain}>
                <div className={s.listTitle}>{device(x.userAgent)} {x.current && <span className={s.chip}>This browser</span>}</div>
                <div className={s.listSub}>Signed in {fullDate(new Date(x.createdAt))} from {x.ip}</div>
              </div>
            </li>
          ))}
        </ul>
        <div className={s.actionsBar}>
          <Button variant="secondary" disabled={others === 0} loading={revoke.isPending} onClick={() => revoke.mutate()}>
            Sign out of {others === 1 ? "1 other session" : `${others} other sessions`}
          </Button>
        </div>
        {revoke.data && <Notice kind="ok">Signed out of {revoke.data.revoked} session{revoke.data.revoked === 1 ? "" : "s"}.</Notice>}
      </section>
    </>
  );
}
